'use client';
import React, { forwardRef } from 'react';
import TooltipBox from './TooltipBox.mjs';
import { TOOLTIP_BOX_VARIANT } from '../../constants/tooltip.mjs';
import useApplyLogging from '../../hooks/useApplyLogging.mjs';

/**
 * [툴팁 컴포넌트 사용법 & props 설명](https://oss.fin.navercorp.com/pages/finance-fe/deFign/v7/?path=/docs/ui_defign-ui-tooltip-overview--docs)
 *
 * 개행하지 않으며, 짧은 문장으로 구성됩니다.
 *
 * - max-width를 넘어가면 말줄임 처리 됩니다.
 */
const TooltipBoxShort = /*#__PURE__*/forwardRef((props, ref) => {
  useApplyLogging('TooltipBoxShort');
  return /*#__PURE__*/React.createElement(TooltipBox, {
    ...props,
    variant: TOOLTIP_BOX_VARIANT.SHORT,
    ref: ref
  });
});
TooltipBoxShort.displayName = 'TooltipBoxShort';

export { TooltipBoxShort as default };
